import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './Component/Home';
import Collection from './Component/Collection';
import Contact from './Component/Contact';
import Aboutus from './Component/Aboutus';
import TrackOrder from './Component/TrackOrder';

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Home/>}></Route>
          <Route path='/collection' element={<Collection/>}></Route>
          <Route path='/contact' element={<Contact/>}></Route>
          <Route path='/Aboutus' element={<Aboutus/>}></Route>
          <Route path='/TrackOrder' element={<TrackOrder/>}></Route>
          
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
